import React from 'react';

import ProjectsDashboardContainer from '@totem/components/ticketing/projectsDashboard/ProjectsDashboardContainer';
import ProjectsDashboardLayout from '@totem/components/ticketing/projectsDashboard/ProjectsDashboardLayout';

const ProjectsDashboardPage = () => (
  <ProjectsDashboardContainer>
    <ProjectsDashboardLayout />
  </ProjectsDashboardContainer>
);

export default ProjectsDashboardPage;
